module.exports = __webpack_public_path__ + "img/folder-search.f33fcf2b.svg";